import * as React from "react";
import TrackedBolResultModel, { CargesModel } from "../../TrackedBolResultsModel";
import { Row, Col, Collapse, Icon, Button, Table } from "antd";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import Utility from "Core/Utility";
import moment from "moment";
import { ColumnProps } from "antd/lib/table";
import { IAddTrackedBolRequestModel, TrackedBolServiceCategory } from "Core/Api/Kopp/Api";
import _ from "lodash";

export interface Props {
    children?: React.ReactNode
    trackedBol: IAddTrackedBolRequestModel
    onDeleteClicked?: (trackedBol: IAddTrackedBolRequestModel) => void;
    onEditClicked?: (trackedBol: IAddTrackedBolRequestModel) => void;
}

export interface State {
}

export default class TrackedBolSearchItem extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    removeItem = (e: React.FormEvent) => {
        e.preventDefault();
        this.props.onDeleteClicked?.call(this, this.props.trackedBol);
    }

    renderCharges(charges: Array<CargesModel> | undefined) {

        if (!charges) {
            return <></>;
        }

        const chargeTableColums: Array<ColumnProps<CargesModel>> = [
            {
                title: 'Charge',
                dataIndex: 'chargeType',
                key: 'chargeType',
            },
            {
                title: 'Amount',
                dataIndex: 'chargeAmount',
                key: 'chargeAmount',
                render: text => `$${text}`,
            },
        ];

        return (
            <Table<CargesModel>
                pagination={charges.length < 3 && false}
                dataSource={charges}
                columns={chargeTableColums}
            />
        );
    }

    render() {
        let result = this.props.trackedBol;
        return (
            // <Row {...centeredRowAttributes} className="react-transition fade-in">
            <Row className="react-transition fade-in">
                {/* <Col {...this.panelColLayout} > */}
                <Col style={{ backgroundColor: "#f8f8f8", padding: "10px", borderRadius: 5, marginBottom: 5 }}>
                    <Row>
                        <Col span={3}>
                            <p>{result.bolNumber?.toUpperCase()}</p>
                        </Col>
                        <Col span={4}>
                            <p>{result.vessel}</p>
                        </Col>
                        <Col span={3}>
                            <p>{moment().format("YYYY-MM-DD")}</p>
                        </Col>
                        <Col span={4}>
                            <p>Valid</p>
                        </Col>
                        <Col span={4}>
                            <p>{!result.serviceCategory ? '' : _.startCase(TrackedBolServiceCategory[result.serviceCategory])}</p>
                        </Col>
                        <Col span={4}>
                            <p>{result.consigneeName}</p>
                        </Col>
                        <Col span={1}>
                            <Icon type="edit" style={{ color: "#00abe3" }} onClick={() => this.props.onEditClicked?.call(this, this.props.trackedBol)} />
                        </Col>
                        <Col span={1}>
                            <Icon type="delete" theme="filled" style={{ color: "#FF6232" }} onClick={this.removeItem} />
                            {/* <Button style={{ border: 'none', backgroundColor: '#f8f8f8' }} onClick={this.removeItem}></Button> */}
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }
}
